import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import TimeSlots$1 from './TimeSlots.js';

const TimeSlotsContainer = (_param)=>{
    var { loading , slots  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "loading",
        "slots"
    ]);
    const { dateTime: { formatTime  } ,  } = useIntl();
    return /*#__PURE__*/ React.createElement(TimeSlots$1, swcHelpers.extends({}, rest, {
        loading: loading,
        slots: slots,
        timeFormatter: formatTime
    }));
};
var TimeSlots = TimeSlotsContainer;

export { TimeSlots as default };
//# sourceMappingURL=TimeSlotsContainer.js.map
